module.exports = __webpack_public_path__ + "static/media/surgeryQuestion.62eff1b9.mp3";